import { industryNewsRecords } from "./industryNews.js";
import { companyNewsRecords } from "./companyNews.js";

const legacyNewsRecords = [
  {
    slug: "industry-500kv-transformer-applications",
    category: "industry",
    title: "500kV变压器常用于什么地方",
    excerpt:
      "围绕高压及超高压输配电应用，对典型产品场景、选型原则与工程规范进行梳理，帮助客户快速理解500kV等级产品的工程定位。",
    date: "2026-04-09",
    views: 30,
    sourceName: "江苏宏邦变压器有限公司",
    sourceUrl: "https://www.ntyw.net/?list_44%2F=",
    content: [
      "500kV变压器主要应用于超高压输电网络的关键枢纽节点，通常服务于跨区域输电、大型负荷中心供电以及骨干电网互联互通等场景。由于其容量大、电压等级高、系统责任重大，因此在工程设计、制造工艺和现场安装调试方面都要求更高。",
      "从实际应用角度看，这类设备常见于大型变电站、重点工业园区配套工程以及新能源大基地外送通道等项目。随着新型电力系统建设推进，500kV级产品不仅承担基础输配电任务，也承担提高区域电网稳定性和可靠性的作用。",
    ]
  },
  {
    slug: "industry-330kv-400kv-ehv-range",
    category: "industry",
    title: "330kV~400kV 是否属于超高压",
    excerpt:
      "聚焦电压等级、典型应用范围与工程认知，帮助客户更清晰地理解330kV~400kV产品在线路建设和区域负荷中的角色。",
    date: "2026-04-09",
    views: 24,
    sourceName: "江苏宏邦变压器有限公司",
    sourceUrl: "https://www.ntyw.net/?list_44%2F=",
    content: [
      "330kV~400kV通常被归入超高压输电应用范围，是连接主网架、承担大容量输送和跨区域供电任务的重要电压等级。与更低等级的输配电设备相比，这一范围内的变压器在绝缘结构、损耗控制、散热设计和系统匹配上都有更高要求。",
      "该类产品广泛应用于区域主干电网、重点产业园供电、大型能源基地并网等场景，在电网扩容与稳定运行中发挥着重要作用。对于设备制造企业来说，这也是体现制造能力和工程交付实力的重要产品带。",
    ]
  },
  {
    slug: "industry-dry-type-operating-conditions",
    category: "industry",
    title: "干式变压器工作条件和要求",
    excerpt:
      "从使用环境、散热条件到安装要求，归纳干式变压器在项目中的关键要点，适合做为客户前期选型参考。",
    date: "2025-09-13",
    views: 749,
    sourceName: "江苏宏邦变压器有限公司",
    sourceUrl: "https://www.ntyw.net/?list_44%2F=",
    content: [
      "干式变压器通常应用于对防火、环保和室内安装要求较高的场景，例如商业建筑、医院、数据中心、轨道交通以及工业配电系统。其工作环境需要兼顾通风条件、环境温度、海拔因素以及防尘、防潮等基本要求。",
      "实际工程中，干式变压器的稳定运行不仅依赖设备本身参数，还依赖于安装空间、散热路径、负荷波动以及运维管理方式。高海拔、高湿度或粉尘环境下，通常需要进一步核对绝缘水平和冷却条件。",
    ]
  },
  {
    slug: "industry-what-is-dry-type-transformer",
    category: "industry",
    title: "干式变压器究竟是什么",
    excerpt:
      "从结构、安全性和适用场景三个角度解释干式变压器的基本特征，帮助非专业访客快速建立概念认知。",
    date: "2025-09-13",
    views: 219,
    sourceName: "江苏宏邦变压器有限公司",
    sourceUrl: "https://www.ntyw.net/?list_44%2F=",
    content: [
      "干式变压器是一类不采用油作为绝缘和冷却介质的变压器产品，常见形式包括树脂浇注型和敞开式结构。其核心优势在于防火性能好、维护便捷、适合室内使用，对商业和公共建筑尤为友好。",
      "与传统油浸式变压器相比，干式产品在某些场景下更强调安全、环保和低噪声特性，但同时也需要关注环境温度、散热条件和安装空间。",
    ]
  },
  {
    slug: "industry-dry-type-safety-notes",
    category: "industry",
    title: "干式变压器安全注意事项",
    excerpt:
      "围绕安装、巡检、温升和环境控制梳理干式变压器运行中的安全边界，是客户和运维方都较关心的常见问题。",
    date: "2024-12-23",
    views: 186,
    sourceName: "江苏宏邦变压器有限公司",
    sourceUrl: "https://www.ntyw.net/?list_44%2F=",
    content: [
      "干式变压器虽然在防火和环保方面有明显优势，但在长期运行中仍需关注温升、绝缘老化、风道堵塞以及负荷波动等问题。尤其在封闭空间和高负载场景中，散热与通风条件往往决定了设备运行的稳定性。",
      "建议在站内展示内容中将这类文章与产品详情页、案例页结合，帮助用户了解从采购到使用阶段的关键关注点。",
    ]
  },
  {
    slug: "industry-dry-type-maintenance",
    category: "industry",
    title: "干式变压器的维护和检修",
    excerpt:
      "从日常巡检、绝缘状态观察到停电检修，梳理干式变压器常见维护思路，适合作为服务型内容补充。",
    date: "2024-12-23",
    views: 164,
    sourceName: "江苏宏邦变压器有限公司",
    sourceUrl: "https://www.ntyw.net/?list_44%2F=",
    content: [
      "干式变压器的维护重点通常包括定期清洁、检查绕组与绝缘表面、确认风机及温控系统运行情况，以及观察是否存在异常振动、异响和局部过热等迹象。",
      "在停电检修阶段，运维人员一般会结合实际工况对紧固件、接线端子、绝缘件及冷却结构进行逐项检查，并建立完整的运维记录。",
    ]
  },
  {
    slug: "industry-oil-immersed-components",
    category: "industry",
    title: "油浸式变压器部件的详细介绍",
    excerpt:
      "从器身、油箱到冷却系统，对油浸式变压器常见组成部分进行分项说明，是非常适合SEO和客户科普的内容方向。",
    date: "2023-12-22",
    views: 138,
    sourceName: "江苏宏邦变压器有限公司",
    sourceUrl: "https://www.ntyw.net/?list_44%2F=",
    content: [
      "油浸式变压器的主要结构一般包括铁芯、绕组、油箱、储油柜、冷却系统、保护附件及绝缘系统等部分，各组成部分共同决定设备的电气性能、温升控制和长期可靠性。",
      "对很多客户来说，真正关心的不只是“参数”，而是这些部件在运行中各自承担什么作用、为什么决定了产品性能和寿命。",
    ]
  },
  {
    slug: "industry-dry-type-capacity-selection",
    category: "industry",
    title: "干式变压器容量的挑选方法",
    excerpt:
      "从负荷需求、安装环境和未来扩容三个维度解释容量选择逻辑，适合做成客户前期咨询前的阅读内容。",
    date: "2023-12-22",
    views: 126,
    sourceName: "江苏宏邦变压器有限公司",
    sourceUrl: "https://www.ntyw.net/?list_44%2F=",
    content: [
      "干式变压器容量选择通常需要综合考虑实际负荷、预估增长、供电可靠性要求以及安装空间等因素，不能只凭额定功率简单匹配。",
      "对于商业建筑、工业负荷和新能源配套项目，不同应用的波动特性和运行模式不同，因此在容量预留、损耗控制和冗余设计上会有不同考量。",
    ]
  },
  {
    slug: "industry-power-equipment-growth-plan-2025-2026",
    category: "industry",
    title: "三部门关于印发《电力装备行业稳增长工作方案（2025-2026年）》的通知",
    excerpt:
      "工信部、市场监管总局、国家能源局联合印发方案，提出到2025—2026年推动传统电力装备稳定增长、强化质量标准与国际市场拓展。",
    date: "2025-09-12",
    views: 98,
    sourceName: "工业和信息化部",
    sourceUrl: "https://www.miit.gov.cn/jgsj/zbes/wjfb/art/2025/art_b091647cde134778baf5394ef16e5bf1.html",
    content: [
      "根据工信部发布的信息，三部门联合印发《电力装备行业稳增长工作方案（2025-2026年）》，明确提出传统电力装备年均营收保持合理增长、新能源装备稳中有升、重点企业和产业集群发挥带动作用等目标。",
      "方案同时强调，通过标准提升带动包括变压器在内的电力装备质量提升和设备更新，并通过重大能源工程和国际市场拓展扩大有效需求。",
    ]
  },
  {
    slug: "industry-transformer-standards-and-quality-forum",
    category: "industry",
    title: "西电西变承办两项行业标准启动会暨变压器高质量发展研讨会",
    excerpt:
      "行业标准启动与高质量发展研讨同步举行，反映出变压器行业在节能评估、设备更新和能效分级方面的标准化趋势。",
    date: "2025-06-09",
    views: 84,
    sourceName: "国际电力网",
    sourceUrl: "https://power.in-en.com/html/power-2460385.shtml",
    content: [
      "公开资讯显示，相关行业组织和研究机构启动了《变压器节能评估与设备更新技术规范》《高阻抗电力变压器能效分级及评定方法》两项标准工作，并围绕行业高质量发展展开研讨。",
      "这类标准工作的推进意味着行业将更加重视设备全生命周期效率、运行性能和节能升级路径，也会对制造企业的产品设计与检测能力提出更高要求。",
    ]
  },
  {
    slug: "industry-offshore-wind-transformer-launch",
    category: "industry",
    title: "中车株洲电机公司66kV-20MVA大容量油浸式海上风电变压器成功下线",
    excerpt:
      "海上风电专用大容量升压变压器成功下线，体现出新能源场景对高等级、专用化变压器的持续需求。",
    date: "2024-12-23",
    views: 71,
    sourceName: "国际风力发电网",
    sourceUrl: "https://wind.in-en.com/html/wind-2455704.shtml",
    content: [
      "根据公开报道，中车株洲电机公司自主研发的66kV-20MVA大容量油浸式海上风电变压器成功下线，被视为我国海上风电高端装备领域的重要进展。",
      "随着海上风电项目持续推进，面向高盐雾、高湿度、高可靠性要求场景的专用变压器产品将成为新能源装备中的重要增长方向。",
      "对变压器企业而言，新能源配套装备的迭代速度和专业场景扩张也意味着更广阔的产品应用空间。"
    ]
  },
  {
    slug: "industry-global-transformer-shortage-ai-grid",
    category: "industry",
    title: "一台变压器等两年？中国厂商连夜赶工，AI算力逼疯全球电网！",
    excerpt:
      "公开行业报道指出，全球电网升级、能源转型与AI算力中心扩张叠加，正在推动大型电力变压器进入供需紧张周期。",
    date: "2026-03-18",
    views: 65,
    sourceName: "国际能源网",
    sourceUrl: "https://www.in-en.com/article/html/energy-2342209.shtml",
    content: [
      "公开行业资讯显示，全球变压器市场正在经历结构性供需变化，北美、欧洲和新兴市场对高等级变压器的需求快速上升，交货周期和价格都出现明显拉长与抬升。",
      "能源转型、电网老化改造和AI数据中心扩容，共同推高了对高可靠供电设备的需求，也让变压器制造企业的交付能力、标准能力和海外适配能力成为竞争核心。",
    ]
  },
  {
    slug: "company-transformer-overseas-and-smart-manufacturing-conference",
    category: "company",
    title: "2025年4月28日至29日“2025中国电力变压器出海及智能制造技术大会”在无锡隆重举行",
    excerpt:
      "江苏宏邦变压器有限公司受邀参会，并荣膺《变压器之声 金鲸·全球电力变压器领军企业奖》，体现了企业在技术创新与国际化布局上的综合实力。",
    date: "2025-04-30",
    views: 673,
    sourceName: "江苏宏邦变压器有限公司",
    sourceUrl: "https://www.ntyw.net/?list_43%2F807.html=",
    images: [
      "https://www.ntyw.net/static/upload/image/20250430/1746003834156017.jpg",
      "https://www.ntyw.net/static/upload/image/20250430/1746003834559514.jpg",
      "https://www.ntyw.net/static/upload/image/20250430/1746003834131111.jpg"
    ],
    content: [
      "2025年4月28日至29日，由上海摩庚企业管理咨询有限公司主办的“2025中国电力变压器出海及智能制造技术大会”在无锡举行。公开页面显示，江苏宏邦变压器有限公司受邀参会，并获得《变压器之声 金鲸·全球电力变压器领军企业奖》。",
      "公开报道中提到，该奖项体现了行业对于企业在技术创新、智能制造和全球化布局方面的认可，也反映出当前变压器制造业对“出海能力”和“智造能力”的双重重视。",
    ]
  },
  {
    slug: "company-7500kva-oil-immersed-shipment-australia",
    category: "company",
    title: "发货｜热烈庆祝江苏宏邦变压器7500kVA油浸式变压器顺利发货澳大利亚！",
    excerpt:
      "两台7500kVA油浸式变压器顺利发货澳大利亚，体现出企业在国际项目执行、出口包装与交付流程方面的稳定能力。",
    date: "2024-12-10",
    views: 188,
    sourceName: "江苏宏邦变压器有限公司",
    sourceUrl: "https://www.ntyw.net/?list_43%2F=",
    content: [
      "公开动态显示，江苏宏邦变压器有限公司生产的两台7500kVA油浸式变压器顺利发货澳大利亚。",
      "这类动态适合作为本站动态中的“交付类内容”，因为它能够直观传达企业出口项目经验、产品标准适配能力以及海外交付执行力。",
    ]
  },
  {
    slug: "company-ep-shanghai-2024",
    category: "company",
    title: "宏邦｜2024年上海国际电力展览会（EP Shanghai 2024）",
    excerpt:
      "企业亮相上海国际电力展，展示输配电装备与出口产品方案，是品牌曝光和市场连接的重要窗口。",
    date: "2024-12-05",
    views: 143,
    sourceName: "江苏宏邦变压器有限公司",
    sourceUrl: "https://www.ntyw.net/?list_43%2F=",
    content: [
      "公开页面显示，宏邦参加了2024年上海国际电力设备及技术展览会（EP Shanghai 2024）。",
      "对制造企业而言，展会动态不仅意味着参展本身，更意味着品牌面向渠道、终端客户和国际合作伙伴进行集中展示的机会。",
    ]
  },
  {
    slug: "company-3000kva-american-box-transformer-canada",
    category: "company",
    title: "发货｜热烈庆祝宏邦研制的3000kVA三相美式箱式变压器顺利发货加拿大！",
    excerpt:
      "面向北美市场的三相美式箱变顺利发货，反映出企业在出口产品线和海外标准适配方面的持续推进。",
    date: "2024-11-29",
    views: 135,
    sourceName: "江苏宏邦变压器有限公司",
    sourceUrl: "https://www.ntyw.net/?list_43%2F=",
    content: [
      "公开本站动态提到，企业研制的3000kVA三相美式箱式变压器顺利发货加拿大。",
      "此类项目通常需要兼顾北美市场的标准要求、包装运输与现场应用习惯，对制造企业的产品设计和交付管理能力都有较高要求。",
    ]
  },
  {
    slug: "company-first-69kv-main-transformer-usa",
    category: "company",
    title: "发货｜热烈庆祝江苏宏邦变压器出口美国首台69kV主变顺利发货！",
    excerpt:
      "首台出口美国69kV主变顺利发货，代表企业在高标准市场的项目突破与国际交付能力提升。",
    date: "2024-11-21",
    views: 129,
    sourceName: "江苏宏邦变压器有限公司",
    sourceUrl: "https://www.ntyw.net/?list_43%2F=",
    content: [
      "公开动态显示，企业自主研发生产的首台出口美国69kV电力变压器顺利发货。",
      "对于输变电装备企业而言，“首台出口”通常意味着资质、标准、试验验证和客户认可的多重突破，因此具有很强的传播价值。",
    ]
  },
  {
    slug: "company-solar-storage-canada-2024",
    category: "company",
    title: "宏邦｜2024年加拿大太阳能及储能展览会（Solar Storage Canada）",
    excerpt:
      "企业亮相加拿大太阳能及储能展，展示新能源配套变压器方案和海外市场拓展节奏。",
    date: "2024-10-24",
    views: 117,
    sourceName: "江苏宏邦变压器有限公司",
    sourceUrl: "https://www.ntyw.net/?list_43%2F=",
    content: [
      "公开内容显示，企业参加了2024年加拿大太阳能及储能展览会。",
      "这一类资讯不仅可归入本站动态，也与新能源产品线、储能应用方案和国际项目布局形成内容联动。",
    ]
  },
  {
    slug: "company-ecuador-220kv-substation-project",
    category: "company",
    title: "发货｜厄瓜多尔75000，220kV变电工程项目",
    excerpt:
      "厄瓜多尔220kV变电工程项目成功发货，体现出企业在海外大型电网工程中的项目组织与交付能力。",
    date: "2024-06-02",
    views: 102,
    sourceName: "江苏宏邦变压器有限公司",
    sourceUrl: "https://www.ntyw.net/?list_43%2F=",
    content: [
      "公开动态中提到，厄瓜多尔75000、220kV变电工程项目成功发货。",
      "这种面向海外工程类项目的动态，非常适合作为企业案例与新闻结合展示，因为它既有项目属性，又能证明产品在复杂场景下的应用能力。",
    ]
  },
  {
    slug: "company-smart-industrial-park-operation-update",
    category: "company",
    title: "站内整理｜智能厂区扩建与投运进度更新",
    excerpt:
      "根据公开公司资料整理，企业持续推进智能厂区扩建与制造升级，为后续规模化交付和高电压等级产品制造打下基础。",
    date: "2024-10-01",
    views: 95,
    sourceName: "官网资料整理",
    sourceUrl: "",
    content: [
      "根据站内公开企业介绍与发展历程资料，宏邦持续推进智能厂区扩建、制造能力升级和重点产品线建设。",
      "这类内容适合以“站内整理”的方式沉淀成公司动态，既便于展示企业成长，也能与发展历程页面形成联动。",
    ]
  },
  {
    slug: "company-international-delivery-capability-upgrade",
    category: "company",
    title: "站内整理｜国际市场项目交付能力持续提升",
    excerpt:
      "结合官网资料中的出口覆盖国家、海外项目与发货记录，整理形成企业国际交付能力专题动态。",
    date: "2024-08-18",
    views: 87,
    sourceName: "官网资料整理",
    sourceUrl: "",
    content: [
      "从官网公开信息可以看到，企业的产品已覆盖多个海外市场，并在北美、南美及其他国际项目中持续形成交付案例。",
      "将分散在公司介绍、产品中心和发货动态中的信息整合为企业交付专题，是提升官网内容完整性的一种有效方式。",
    ]
  },
  {
    slug: "company-export-and-new-energy-projects-progress",
    category: "company",
    title: "站内整理｜出口产品与新能源项目协同推进",
    excerpt:
      "围绕出口产品线、新能源应用场景和海外展会参与情况，整理形成企业年度动态补充内容。",
    date: "2024-07-12",
    views: 79,
    sourceName: "官网资料整理",
    sourceUrl: "",
    content: [
      "根据站内公开的产品结构与企业动态，出口产品、新能源配套变压器及储能相关项目已成为企业内容展示中的重要方向。",
      "从官网运营的角度，将这些内容整理成动态文章，能够让访客更加清楚企业在传统输配电之外的业务延展。",
    ]
  }
];

export const newsRecords = [
  ...industryNewsRecords,
  ...companyNewsRecords,
  ...legacyNewsRecords.filter((item) => item.category !== "industry" && item.category !== "company")
];

export function getNewsByCategory(category) {
  return newsRecords
    .filter((item) => item.category === category)
    .sort((a, b) => new Date(b.date) - new Date(a.date));
}

export function getNewsTabs() {
  return {
    industry: getNewsByCategory("industry").slice(0, 10),
    company: getNewsByCategory("company").slice(0, 5)
  };
}

export function getNewsBySlug(slug) {
  return newsRecords.find((item) => item.slug === slug);
}

export function getRelatedNews(item, limit = 5) {
  if (!item) {
    return [];
  }

  return getNewsByCategory(item.category)
    .filter((entry) => entry.slug !== item.slug)
    .slice(0, limit);
}

export function getLatestNews(limit = 5) {
  return [...newsRecords]
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .slice(0, limit);
}
